import { BrandingImage, BrandingStyle, DisabledPrompt } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";
/**
 * @function HeaderView 
 * @param {OBJECT} props - Default React.Components props OBJECT
 * @returns {React.Component}
 * @example
 * <Page>
 *  <HeaderView />
 * </Page>
 */
export default function HeaderView(props) {
  return (
    <BrandingStyle style={{ "backgroundColor": "header_bg_rxp22" }} className="page-header flex-container flex-horizontal align-center">
      <div className="flex-width justify-left">
        <div className="bank-logo">
          <BrandingImage id="fi_logo_rxp22" className="bank-logo" alt="Financial Institution Logo" />
        </div>
      </div>
      <div className="set-width">
        <DisabledPrompt>
          <BrandingStyle style={{ "color": "page_header_text_rxp22" }} className="log-out-button clickable" element={<span>Sign Out</span>} />
        </DisabledPrompt>
      </div>
    </BrandingStyle>
  )
}